import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wyw_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitEnquiry = (payload) => api.post('/enquiries', payload).then(r => r.data);
export const submitSubscription = (email) => api.post('/subscribe', { email }).then(r => r.data);
export const listProducts = (section) => api.get('/products', { params: section ? { section } : {} }).then(r => r.data);

export const adminLogin = (email, password) => api.post('/admin/login', { email, password }).then(r => r.data);
export const adminMe = () => api.get('/admin/me').then(r => r.data);
export const adminListEnquiries = () => api.get('/admin/enquiries').then(r => r.data);
export const adminDeleteEnquiry = (id) => api.delete(`/admin/enquiries/${id}`).then(r => r.data);
export const adminUpdateEnquiryStatus = (id, status_val) => api.patch(`/admin/enquiries/${id}`, null, { params: { status_val } }).then(r => r.data);
export const adminExportUrl = () => `${API}/admin/enquiries/export`;

export const adminListProducts = () => api.get('/admin/products').then(r => r.data);
export const adminCreateProduct = (body) => api.post('/admin/products', body).then(r => r.data);
export const adminUpdateProduct = (id, body) => api.put(`/admin/products/${id}`, body).then(r => r.data);
export const adminDeleteProduct = (id) => api.delete(`/admin/products/${id}`).then(r => r.data);

// Logos
export const adminListLogos = () => api.get('/admin/logos').then(r => r.data);
export const adminUploadLogo = (file, name) => {
  const fd = new FormData();
  fd.append('file', file);
  if (name) fd.append('name', name);
  return api.post('/admin/logos', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const adminUpdateLogo = (id, params) => api.patch(`/admin/logos/${id}`, null, { params }).then(r => r.data);
export const adminDeleteLogo = (id) => api.delete(`/admin/logos/${id}`).then(r => r.data);
export const adminReorderLogos = (orderedIds) => api.post('/admin/logos/reorder', orderedIds).then(r => r.data);

// Banners
export const adminListBanners = () => api.get('/admin/banners').then(r => r.data);
export const adminCreateBanner = (body) => api.post('/admin/banners', body).then(r => r.data);
export const adminUpdateBanner = (id, body) => api.put(`/admin/banners/${id}`, body).then(r => r.data);
export const adminDeleteBanner = (id) => api.delete(`/admin/banners/${id}`).then(r => r.data);

// Generic image upload
export const adminUploadImage = (file, kind = 'products') => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/admin/upload/image', fd, { params: { kind }, headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};

// Password change
export const adminChangePassword = (body) => api.post('/admin/password', body).then(r => r.data);

export const backendUrl = (path) => path?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export default api;
